import {LoggerService} from '../common/LoggerService';
import {TokenStore} from './TokenStore';

/**
 * Delegates to TokenStore: access token in memory only, no localStorage.
 * Use TokenStore directly for refresh token and clear().
 */
export class TokenStorage {
  async getToken (): Promise<string | null> {
    try {
      return TokenStore.getAccessToken();
    } catch (error) {
      LoggerService.error('TokenStorage: Error getting token:', error, 'TokenStorage');
      return null;
    }
  }

  async setToken (token: string): Promise<void> {
    try {
      TokenStore.setAccessToken(token);
    } catch (error) {
      LoggerService.error('TokenStorage: Error setting token:', error, 'TokenStorage');
      throw error;
    }
  }

  async removeToken (): Promise<void> {
    try {
      TokenStore.clear();
    } catch (error) {
      throw error;
    }
  }
}
